import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import MostActiveContractsFull from './most-active-contracts-full';

const MostActiveContractsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <MostActiveContractsFull {...props} />
    </QueryClientProvider>
  );
};

export { MostActiveContractsFullWidget }
